/** De duur van een afspraak waaruit je kiest, in minuten. */
export const DURATIONS = [60, 90, 120, 150, 180, 240] as const;

/** `2026-09-21` + `09:00` in de tijdzone van dit apparaat. */
export function localMoment(date: string, time: string): Date {
    return new Date(`${date}T${time}`);
}

/**
 * Zoals de API tijden wil: ISO 8601 met tijdzone. Altijd in UTC (`+00:00`):
 * de API bewaart een tijd met een andere offset nu als kloktijd in UTC, zodat
 * `09:00+02:00` terugkomt als `09:00+00:00`. In UTC klopt het moment hoe dan ook.
 */
export function toApiMoment(moment: Date): string {
    return `${moment.toISOString().slice(0, 19)}+00:00`;
}
